import React, { createContext, useReducer } from "react";
export const Chatcontext=createContext();
const defaultreducer={
    chatid:"null",
    isfinish:true,
};
const reducer=(state,action)=>{
    if(action.type==="changeuser"){
        return{
            chatid:action.chatid
        }
    }
    if(action.type==="changefinish"){
        return{
            isfinish:action.isfinish
        }
    }

}
export const Chatcontextprovider=(props)=>{
    
    const [chat, dispatchchat]=useReducer(reducer,defaultreducer)
    const changethechat=(chatid)=>{
        dispatchchat({type:"changeuser" , chatid:chatid})
    }
    const changethefinish=(isfinish)=>{
        dispatchchat({type:"changefinish" , isfinish:isfinish})
    }
    const chatcontext={
        chatid:chat.chatid,
        isfinish:chat.isfinish,
        changechat:changethechat,
        changefinish:changethefinish,
    }
    return(
        <Chatcontext.Provider value={chatcontext} >
            {props.children}
        </Chatcontext.Provider>
    )
}